<template>
  <div>
    <!-- <div class="hidden-md-and-down"> -->
    <div>
      <el-table
        :data="salesOrders"
        stripe
        v-loading:loading
        style="width: 100%;"
        :cell-style="{padding:'2px'}">
        <div slot="empty">
          <span>{{$t('sales_orders.no_sales_orders')}}</span>
        </div>
        <el-table-column
          :label="$t('sales_orders.soNumber')"
          prop="so_number"
          width="160"
          sortable>
          <template slot-scope="scope">
            <PortausLink :id="scope.row.id" :label="scope.row.so_number || scope.row.soNumber" path="/sales-orders/" :underline="true"></PortausLink>
          </template>
        </el-table-column>
        <el-table-column
          prop="sales_rep.name"
          sortable
          :label="$t('sales_orders.rep')">
          <template slot-scope="scope">
              <span v-if="scope.row.rep == null && scope.row.sales_rep == null"> -- </span>
              <span v-else>
                <span v-if="scope.row.sales_rep" style="word-break: break-word;">{{scope.row.sales_rep.first_name}} {{scope.row.sales_rep.last_name}}</span>
                <span v-if="scope.row.rep" style="word-break: break-word;">{{scope.row.rep.firstName}} {{scope.row.rep.lastName}}</span>
              </span>

          </template>
        </el-table-column>
        <el-table-column
          :label="$t('sales_orders.date')"
          prop="date"
          width="100"
          sortable>
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.date">{{_moment(scope.row.date)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('sales_orders.expectedDeliveryDate')"
          prop="expected_delivery_date"
          width="100"
          sortable>
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.date">{{_moment(scope.row.expected_delivery_date)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.reference')"
          prop="reference"
          width="100"
          sortable>
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.reference">{{scope.row.reference}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status.code"
          :label="$t('common.status')"
          sortable>
          <template slot-scope="scope">
            <el-tag  size="small" style="margin-left:10px;">{{$t("sales_orders.statuses."+scope.row.status.code)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('sales_orders.tags')">
          <template slot-scope="scope">
            <el-tag v-for="t in scope.row.tags" :key="t.id" size="small">{{t.code}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="hidden-lg-and-up">
      <div v-for="so in salesOrders" :key="so.id">
        <SalesOrderTile @click="openSalesOrder(so.id)"  :customer="so.customer" :shipping_contact="so.shippingContact" :inv_number="so.invNumber" :reference="so.reference" :date="so.date" :total="so.total" :status="so.status" :sales_rep="so.salesRep"></SalesOrderTile>
        <el-divider />
      </div>
    </div> -->
  </div>
</template>
<script>
import moment from 'moment-business-days'
import SalesOrderTile from '@/components/salesOrder/Sales-order-tile'
import PortausLink from '@/components/portaus-link'

export default {
  name: 'sales-order-table',
	props: {
    salesOrders : Array,
	},
  data() {
    return {
      type : 'SET_ASIDE',
      loading : true,
    };
  },components: {
    SalesOrderTile,
    PortausLink
  },
  watch : {

  },
	methods: {
    _moment(datetime, format='DD/MM/YYYY'){
      return moment(datetime).format(format);

    },
    openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
      this.$router.push(index);
    }
	},
	computed: {


	}
}
</script>
<style lang="scss" scoped>




</style>
